/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

export default class Workflow extends Route {
  @service declare appService: $TSFixMe;
  @service declare router: RouterService;

  async beforeModel(transition: Transition) {
    if (
      !this.appService.app.canAccessSalesforceCasesRedesign &&
      transition.to?.name !== 'apps.app.standalone.deploy.salesforce.cases.workflow.show'
    ) {
      this.router.transitionTo('apps.app.standalone.deploy.salesforce.cases');
    }
  }
}
